import { round } from 'lodash'

import { isUndefinedOrNull } from './checks'

/**
 * Arredonda o valor para o número de casas decimais desejadas e formata para texto
 * @param value valor a ser formatado
 * @param precision número de casas decimais desejadas
 * @param useGrouping se deve usar separador de milhar (padrão: true)
 */
export function formatNumber(value: number | string, precision?: number, useGrouping: boolean = true): string {
  const numberValue = typeof value === 'number' ? value : parseNumber(value)
  if (isNaN(numberValue)) return value as string

  const valueToFormat = isUndefinedOrNull(precision) ? numberValue : round(numberValue, precision)

  const formatter = new Intl.NumberFormat('pt-BR', {
    useGrouping,
    ...(isUndefinedOrNull(precision)
      ? {}
      : {
          minimumFractionDigits: precision,
          maximumFractionDigits: precision,
        }),
  })

  return formatter.format(valueToFormat)
}

export function parseNumber(value: string) {
  if (value) {
    const unlocalizedValue = value.replace('.', '').replace(',', '.')
    if (unlocalizedValue.includes('.')) {
      return parseFloat(unlocalizedValue)
    } else {
      return parseInt(unlocalizedValue)
    }
  }
  return undefined
}

/**
 * Usado para pegar a precisão de um número
 */
export const getNumberPrecision = (value: number) => {
  const stringfied = value.toString()
  const dotPos = stringfied.indexOf('.')

  return dotPos > -1 ? stringfied.slice(dotPos + 1, stringfied.length).length : 0
}

export function parseFraction(value: string) {
  if (value) {
    if (value.includes('/')) {
      if (!value.endsWith('/') && !value.endsWith('0')) {
        const numbersArray = value.split('/')
        const numerator = parseInt(numbersArray[0])
        const denominator = parseInt(numbersArray[1])
        return round(numerator / denominator, 3)
      }
    } else {
      return parseNumber(value)
    }
  }
  return undefined
}

export function areNumericallyEqual(initialValue: string | number, currentValue: string | number): boolean {
  const initialValueNormalized = normalizeToNumber(initialValue)
  const currentValueNormalized = normalizeToNumber(currentValue)

  return (
    !isNaN(initialValueNormalized) &&
    !isNaN(currentValueNormalized) &&
    initialValueNormalized === currentValueNormalized
  )
}

function normalizeToNumber(value: string | number): number {
  if (typeof value === 'number') return value
  if (typeof value === 'string') return parseNumber(value)
  return NaN
}
